import { render, staticRenderFns } from "./DependentVisa.vue?vue&type=template&id=1af8fbc0&"
import script from "./DependentVisa.vue?vue&type=script&lang=js&"
export * from "./DependentVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports